'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Admin').service('ReminderCommonService', ['CommonService','CommonPostService', function (CommonService,CommonPostService) {

	//###################  GET EASY FORM REMINDER DUES COUNT BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET EASY FORM REMINDER DUES COUNT
	///*******CREATED BY: RAVI TEJA.P
	///*******CREATED DATE: 02/22/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatestLatestEasyFormsRemaindersDuesCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		//       return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "htmlTemplatestLatestEasyFormsRemaindersDuesCount", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderDues_API_Net8() + "htmlTemplatestLatestEasyFormsRemaindersDuesCount", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  EASY FORM REMINDER DUES COUNT  BLOCK END #########################

	//###################  GET EASY FORM PRACTICE BASED REMINDER DUES COUNT BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET EASY FORM REMINDER DUES COUNT
	///*******CREATED BY: AMARNATH
	///*******CREATED DATE: 03/24/2020
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatestEasyFormsRemainderHRDuesCountGet = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		//if (hasValue(showBusyCursor))
		//    postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderDues_API_Net8() + "EasyFormsRemainderHRDuesCountGet", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  EASY FORM REMINDER DUES COUNT  BLOCK END #########################

	//###################  GET EASY FORM PRACTICE BASED REMINDER DUES COUNT BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO GET EASY FORM REMINDER DUES COUNT
	///*******CREATED BY: RAVI TEJA.P
	///*******CREATED DATE: 02/22/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatestHRBasedRemaindersDuesCount = function (postData, showBusyCursor) {
		postData.practicemodel = EMRPracticeModel;

		if (hasValue(showBusyCursor))
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;


		//   return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "htmlTemplatestHRBasedRemaindersDuesCount", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderDues_API_Net8() + "htmlTemplatestHRBasedRemaindersDuesCount", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  EASY FORM REMINDER DUES COUNT  BLOCK END #########################




	//###################  EXECUTE EASY FORM REMINDER RULES BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO EXECUTE EASY FORM REMINDER RULES
	///*******CREATED BY: RAVI TEJA.P
	///*******CREATED DATE: 02/24/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.EasyFormsExecuteEasyFormRemainderRules = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.QuestBusinessUnitsUsingForLoggedPractice = EMRPracticeModel.practicesettingsmodel.QuestBusinessUnitsUsingForLoggedPractice;
		postData.PracticeName = EMRPracticeModel.PracticeName;
		postData.LoggedUserName = EMRPracticeModel.LoggedUserName;
		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		//     return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "ExecuteEasyFormRemainderRules", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderRules_API() + "ExecuteEasyFormRemainderRules", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  EXECUTE EASY FORM REMINDER RULES BLOCK  END #########################

	///  *******PURPOSE:THIS IS USED TO AUTO EXECUTE EASY FORM REMINDERS FOR A PATIENT MODULE WISE
	//*******CREATED BY: DURGA PRASAD V
	//*******CREATED DATE:08/03/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.EasyFormsRemaindersRuleAutoExecutionforPatient = function (postData) {

		postData.practicemodel = EMRPracticeModel;

		var timeOut = 60 * 1000 * 4;

		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

		//    return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "EasyFormsRemaindersRuleAutoExecutionforPatient", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderRules_API() + "EasyFormsRemaindersRuleAutoExecutionforPatient", postData, timeOut).then(
			function (result) {
				return result;
			});



	};
	//################### NEW BLOCK END #########################

	//###################  UPDATE EASY FORM REMINDER DUE STATUS BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO UPDATE EASY FORM REMINDER DUE STATUS
	///*******CREATED BY: UDAY KIRAN V
	///*******CREATED DATE: 02/16/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplatesUpdateEasyFormReminderDueStatus = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		//      return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "UpdateEasyFormReminderDueStatus", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderDues_API_Net8() + "UpdateEasyFormReminderDueStatus", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  UPDATE EASY FORM REMINDER DUE STATUS BLOCK END #########################

	//###################  GET ALL REMINDER RULES AND ITS FILTERS LIST IN PRACTICE - BLOCK START ##############################
	/// ***********PURPOSE: THIS METHOD IS USED TO GET ALL REMINDER RULES AND ITS FILTERS LIST IN PRACTICE
	/// ********CREATED BY: AHMED BASHA SHAIK
	/// ********CREATED ON: 06/11/2018
	/// *******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; **************
	this.HTMLTemplateServiceGetAllReminderRulesAndItsFiltersListInPractice = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Reports_EHRReminders() + "GetAllReminderRulesAndItsFiltersListInPractice", postData).then(
			function (result) {
				return result;
			});
	};
	//###################  GET ALL REMINDER RULES AND ITS FILTERS LIST IN PRACTICE - BLOCK END ##############################

	//###################  SAVE EASY FORM  REMINDER RULES BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS USED TO SAVE EASY FORM  REMINDER RULES
	///*******CREATED BY: RAVI TEJA.P
	///*******CREATED DATE: 3/2/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.EasyFormsSaveEasyFormRemainderdues = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		// postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
		//    return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "SaveEasyFormRemainderdues", postData).then(
		return CommonService.PostData('POST', CommonService.EHR_EF_ReminderDues_API_Net8() + "SaveEasyFormRemainderdues", postData).then(
			function (result) {
				return result;
			});
	};
    //###################  EXECUTE EASY FORM REMINDER RULES BLOCK  END #########################

	//###################   SAVE REMINDERS DUE SETTINGS -  BLOCK START ##############################
	/// *******PURPOSE:THIS METHOD TO SAVE REMINDERS DUE SETTINGS
	///*******CREATED BY:  DURGA PRASAD V
	///*******CREATED DATE: 4/20/2018
	///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************   
	this.HTMLTemplateServiceGetRemindersDueSettings = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_EF_Remainders_API() + "GetEasyFormsRemainderDuesSettings", postData).then(
			function (result) {
				return result;
			});

	};
	//###################  DELETE EASY FORM PRINT BUTTON CUSTOMIZATIONT  BLOCK END ##############################

}]);